import { Dispatch } from '@reduxjs/toolkit';
import { NavigateFunction } from 'react-router-dom';
import { logOut } from '../store/slices/userSlice';

export const logoutHandler = (
  dispatch: Dispatch,
  navigate: NavigateFunction
) => {
  dispatch(logOut()); // پاک‌کردن state از Redux
  localStorage.removeItem('persist:root'); // اگر از redux-persist استفاده می‌کنی
  navigate('/'); // ریدایرکت به لاگین
};